import { render, staticRenderFns } from "./IconClose04.vue?vue&type=template&id=8f123dbc"
import script from "./IconClose04.vue?vue&type=script&lang=js"
export * from "./IconClose04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports